/**
 * @fileoverview My Page KPI query hook.
 * @description Wraps GET /sales/targets/summary in a TanStack query.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getMyPageSummary } from '@/features/sales/services/my-page-targets.service'

/**
 * @description Fetches the My Page KPI counts.
 * @returns {ReturnType<typeof useQuery>} The query (data is the summary).
 */
export function useMyPageSummary() {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.myPageSummary,
    queryFn: getMyPageSummary,
  })
}
